module.exports = "/images/arrow-1.svg?35fb4498cfd3c7877cd7146cc7236c27";